import { memo } from "react";
import { ECommerceOnboarding } from "consts/ecommerce";
import { useOnboardingApplication } from "./hooks";
import { OnboardingInitialStepRedirect } from "../common";

type Props = {
    readonly prefix?: string;
};

const OnboardingMerchantInitialStepRedirect = ({ prefix = '' }: Props) => {
    const {
        getApplicationModel
    } = useOnboardingApplication();

    return (
        <OnboardingInitialStepRedirect
            getApplicationModel={getApplicationModel}
            prefix={prefix}
            applicationType={ECommerceOnboarding.Merchant}
        />
    );
};

export default memo(OnboardingMerchantInitialStepRedirect);
